import { Dialog } from "../../../../../common/core-ui/Dialog.tsx";
import { useIntl } from "react-intl";
import { CourseMaterial } from "../coursesLoader.ts";
import EmptyAssetCard from "../../../../../common/features/asset/EmptyAssetCard.tsx";
import MaterialMetaData from "../MaterialMetaData.tsx";
import styles from "./TermOrdersReturnDialog.module.scss";
import WhiteAssetCardContainer from "../../../../../common/features/asset/WhiteAssetCardContainer.tsx";
import { ReactNode } from "react";

function MaterialCard({ material }: { material: CourseMaterial }) {
  return (
    <WhiteAssetCardContainer
      tagName="li"
      className={styles.whiteCard}
      key={material.id}
    >
      <EmptyAssetCard vbid={material.vbid} type="horizontal" tagName="div">
        <MaterialMetaData courseMaterial={material} size="small" />
      </EmptyAssetCard>
    </WhiteAssetCardContainer>
  );
}

export default function TermOrdersReturnDialog({
  onRequestClose,
  itemsToReturn,
  description,
}: {
  onRequestClose: () => void;
  itemsToReturn: CourseMaterial[];
  description: ReactNode;
}) {
  const intl = useIntl();

  if (!itemsToReturn || itemsToReturn.length === 0) {
    return null;
  }

  return (
    <Dialog
      onRequestClose={onRequestClose}
      title={intl.formatMessage(
        {
          defaultMessage:
            "{count, plural, one {You Need to Return Your Item} other {You Need to Return Your Items}}",
        },
        { count: itemsToReturn.length }
      )}
    >
      {description}
      <ul>
        {itemsToReturn.map((material) => (
          <MaterialCard key={material.id} material={material} />
        ))}
      </ul>
    </Dialog>
  );
}
